import React, { Component } from "react";
import PayloadsList from "./PayloadsList";
import PagesList from "./PagesList";
import MenuItems from "./MenuItems";
import Icon from "./Icons";
import { l } from "../functions";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  return {
    toCopy: state.rootReducer.toCopy || null,
  };
};

const ucFirst = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};
class PagesPalette extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentTab: 1,
      currentPayload: "pages",
    };

    this.showPayloadList = this.showPayloadList.bind(this);
  }

  componentDidMount() {
    if (this.props.toCopy) {
      //Perform some operation here
      this.setState({ currentTab: this.props.toCopy !== null ? 1 : 2 });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.toCopy !== this.props.toCopy) {
      //Perform some operation here
      this.setState({ currentTab: this.props.toCopy !== null ? 1 : 2 });
    }
  }

  showPayloadList = (target) => {
    this.setState({
      currentPayload: target,
    });
  };

  render() {
    console.log(this.props.toCopy);
    return (
      <div className="palette-tab">
        {!this.props.toCopy && (
          <ul className="tab-head">
            <li
              className={this.state.currentTab === 1 ? "active" : ""}
              onClick={() => {
                this.setState({ currentTab: 1 });
              }}
            >
              {l("Pages")}
            </li>
            {this.props.toCopy === null && (
              <li
                className={this.state.currentTab === 2 ? "active" : ""}
                onClick={() => {
                  this.setState({ currentTab: 2 });
                }}
              >
                {l("Navigation")}
              </li>
            )}
          </ul>
        )}
        <ul className="tab-body">
          {this.state.currentTab === 1 && (
            <li>
              {(this.state.currentPayload === "pages" && (
                <PagesList
                  currentPage={this.props.currentPage}
                  goToLayout={this.showPayloadList}
                />
              )) || (
                <div
                  className={`payloads-list ${
                    this.props.toCopy ? "copy-list" : ""
                  }`}
                >
                  <div className="head">
                    <h3>
                      {ucFirst(this.state.currentPayload)} {l("Page Layouts")}
                    </h3>
                    <Icon
                      icon="angle-left"
                      onClick={() => {
                        this.showPayloadList("pages");
                      }}
                    />
                  </div>
                  <div className="form">
                    <PayloadsList
                      currentPage={this.props.currentPage}
                      target={this.state.currentPayload}
                    />
                  </div>
                </div>
              )}
            </li>
          )}
          {this.state.currentTab === 2 && (
            <li>
              <MenuItems />
            </li>
          )}
        </ul>
      </div>
    );
  }
}

export default connect(mapStateToProps)(PagesPalette);
